'use client';
import React from 'react';
import { Stack, TextField, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import CurrencySelect from './CurrencySelect';
import { DEFAULT_CURRENCY_CODE } from '../../constants/defaults';

const DocumentCurrencyInput = ({ control, errors, readOnly, documentCurrencyCode, setValue }) => {
  const showConversion = documentCurrencyCode !== DEFAULT_CURRENCY_CODE;

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      alignItems={{ xs: 'stretch', sm: 'center' }}
      flexWrap="wrap"
    >
      {showConversion && (
        <Typography variant="body1" sx={{ minWidth: 'fit-content' }}>
          One
        </Typography>
      )}

      <Controller
        name="document_currency_code"
        control={control}
        render={({ field }) => (
          <CurrencySelect
            control={control}
            errors={errors}
            name="document_currency_code"
            readOnly={readOnly}
            helperText=""
            onChange={(newCode) => {
              // Update the currency code
              field.onChange(newCode);
              const resetExchangeRate =
                newCode === DEFAULT_CURRENCY_CODE
                  ? null
                  : {
                      source_currency_code: newCode,
                      target_currency_code: DEFAULT_CURRENCY_CODE,
                      calculation_rate: null,
                    };
              setValue('tax_exchange_rate', resetExchangeRate);
            }}
          />
        )}
      />

      {showConversion && (
        <Typography variant="h6" sx={{ minWidth: 'fit-content' }}>
          =
        </Typography>
      )}

      {showConversion && (
        <Stack direction="row" spacing={1} alignItems="center">
          <Controller
            name="tax_exchange_rate"
            control={control}
            render={({ field }) => {
              const { value, onChange } = field;

              return (
                <TextField
                  type="number"
                  id="conversion_rate_per_OMR"
                  label="Conversion Rate"
                  variant="outlined"
                  sx={{ minWidth: '150px' }}
                  size="small"
                  error={!!errors.tax_exchange_rate?.calculation_rate}
                  helperText={errors.tax_exchange_rate?.calculation_rate?.message || undefined}
                  value={value?.calculation_rate ?? ''}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (input === '' || /^\d*\.?\d{0,7}$/.test(input)) {
                      onChange({
                        source_currency_code: documentCurrencyCode,
                        target_currency_code: DEFAULT_CURRENCY_CODE,
                        calculation_rate: input === '' ? null : Number(input),
                      });
                    }
                  }}
                  inputProps={{
                    readOnly,
                  }}
                />
              );
            }}
          />
          <Typography variant="body1" sx={{ minWidth: 'fit-content' }}>
            {DEFAULT_CURRENCY_CODE}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default DocumentCurrencyInput;
